const HomeBlogsArray = () => {
  const myBlogs = [
    {
      datetime: "22-03-2022",
      title: "yoga for everyone 2023",
      about:
        "This is program designed to make the practice of yoga beneficial for people of all ages, abilities, and backgrounds.",
    },
    {
      datetime: "27-04-2022",
      title: "getting back into crossfit after vacation",
      about:
        "Learn how to ease back into your CrossFit routine after a vacation with tips and strategies for success.",
    },
    {
      datetime: "22-05-2022",
      title: "meet fitness ambassador grace",
      about:
        "Get to know Grace, a fitness enthusiast and dedicated ambassador who is passionate about helping others reach their fitness goals.",
    },
  ];
  return myBlogs;
};

export default HomeBlogsArray;
